import React, {Component} from 'react';
import {Tab, Tabs} from 'material-ui';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';
import EditTranslationIcon from 'material-ui-icons/BorderColor';
import RevisionsIcon from 'material-ui-icons/Build';
import ViewTranslationIcon from 'material-ui-icons/Visibility';
import BlockTranslationCreate from './BlockTranslationCreate';
import TranslationRevisionsList from './TranslationRevisionsList';
import TranslationViewContent from './TranslationView';
import {setTranslationEditTabs} from '../../layout/actions';
import {canEditOrViewTranslation} from '../../../components/permissions/permissions';
import {fetchBlock, fetchBlockSiteTranslation} from '../thunks';

class TranslationEditTabs extends Component {
    componentWillMount() {
        this.props.fetchBlock(this.props.match.params.blockId);
        this.props.fetchBlockSiteTranslation(
            this.props.match.params.blockId,
            this.props.match.params.siteId
        );
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleChange = (event, value) => {
        this.props.setTranslationEditTabs(
            value,
            this.props.match.params.blockId,
            this.props.match.params.siteId
        );
    };

    render() {
        const {activeTabData, blockSiteTranslation, block} = this.props;

        let activeTab = 0;

        if (activeTabData[this.props.match.params.blockId]) {
            activeTab = activeTabData[this.props.match.params.blockId];
        }

        const EditTranslationTab = () => (
            <Tabs
                value={activeTab}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab icon={<EditTranslationIcon />} label="Edit Translation" />
                <Tab icon={<RevisionsIcon />} label="Translation Revisions" />
            </Tabs>
        );
        const ViewTranslationTab = () => (
            <Tabs
                value={activeTab}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab icon={<ViewTranslationIcon />} label="View Translation" />
                <Tab icon={<RevisionsIcon />} label="Translation Revisions" />
            </Tabs>
        );

        const EditTranslationActiveTab = () => (
            <BlockTranslationCreate
                block={block}
                blockId={this.props.match.params.blockId}
                blockSiteTranslation={blockSiteTranslation}
                siteId={this.props.match.params.siteId}
            />
        );
        const ViewTranslationActiveTab = () => (
            <TranslationViewContent
                blockSiteTranslation={blockSiteTranslation}
            />
        );

        let EditOrViewTranslationTab = canEditOrViewTranslation(
            EditTranslationTab,
            ViewTranslationTab
        );
        let EditOrViewTranslationActiveTab = canEditOrViewTranslation(
            EditTranslationActiveTab,
            ViewTranslationActiveTab
        );

        return (
            <div>
                <EditOrViewTranslationTab />
                {activeTab === 0 && blockSiteTranslation && block && (
                    <EditOrViewTranslationActiveTab />
                )}
                {activeTab === 1 && blockSiteTranslation && block && (
                    <TranslationRevisionsList
                        blockId={block.id}
                        siteId={this.props.match.params.siteId}
                        blockSiteTranslationId={blockSiteTranslation.id}
                        blockSiteTranslation={blockSiteTranslation}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    activeTabData: state.layout.activeTranslationEditTabs,
    block: state.blocks.block,
    blockSiteTranslation: state.blocks.blockSiteTranslation,
});

export default connect(mapStateToProps, {
    setTranslationEditTabs,
    fetchBlock,
    fetchBlockSiteTranslation,
})(TranslationEditTabs);



// WEBPACK FOOTER //
// ./src/containers/blocks/translations/TranslationEditTabs.jsx